import { ProgressSpinner } from "primereact/progressspinner";
import React, { useState } from "react";
import { useParams,useNavigate } from 'react-router-dom';
import iconDownload from "../../../assets/img/interna/download.png";
import { CertificadoFCursoAdmiNotas } from '../../../services/CertificadosServices';
import { DescargarListaMaterialesCurso,DescargarListaMaterialesUnidad } from '../../../services/MaterialService';
import { ObtenerCertificadoPersonaCurso } from '../../../services/UsuarioService';
import CardDownload from "./components/CardDownload";
import useAlumno from "../../../hooks/useAlumno";
import { PrivateRoutes } from "../../../routes/routes";
import { handleDownloadCertificado, urlToShare } from "../../../helpers/helpers";
import { toast } from "react-toastify";
import * as constantes from "../../../constants/constantes.js";


function GroupCardDownload({ cursoPersona, isButtonDisabledMateriales, spinnerMateriales, setButtonDisabledMateriales, setspinnerMateriales, curso, Evaluaciones, listaUnidades, duracionEnHoras, Persona ,setspinnerCertificado,spinnerCertificado,setspinnerNotas,spinnerNotas}) {
    const [isButtonDisabledCertificado, setButtonDisabledCertificado] = useState(false);
    const [isButtonDisabledNotas, setButtonDisabledNotas] = useState(false);
    const navigate = useNavigate();
    let { configuraciones } = useAlumno();
    let { idCurso } = useParams();
    const handleDownloadMaterialesCurso2 = async () => {
        try {
            let jwt = window.localStorage.getItem("jwt");
            setButtonDisabledMateriales(true);
            setspinnerMateriales(true);
            const data = await DescargarListaMaterialesCurso({ jwt, idCurso });
            const byteCharacters = atob(data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/octet-stream" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", curso.nombre + "_Materiales.zip");
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);
            setButtonDisabledMateriales(false);
            setspinnerMateriales(false);
        } catch (error) {
            alert("Error al descargar materiales del curso");
            setButtonDisabledMateriales(false);
            setspinnerMateriales(false);
        }
    };
    const handleDownloadMaterialesCurso = async () => {
        for(var i = 0; i < listaUnidades.length; i++){
            try {
                let jwt = window.localStorage.getItem("jwt");
                setButtonDisabledMateriales(true);
                setspinnerMateriales(true);
                const data = await DescargarListaMaterialesUnidad({ jwt, idUnidad: listaUnidades[i].idUnidad });
                const byteCharacters = atob(data);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: "application/octet-stream" });
                const url = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", listaUnidades[i].descripcionSEO + "_Materiales.zip");
                document.body.appendChild(link);
                link.click();
                link.remove();
                URL.revokeObjectURL(url);
                setButtonDisabledMateriales(false);
                setspinnerMateriales(false);
            } catch (error) {
                alert("Error al descargar materiales del curso");
                setButtonDisabledMateriales(false);
                setspinnerMateriales(false);
            } 
        }
        
    };
    function calcularPromedioNotasPorUnidad() {
        //obtenerPorcentajeAvance();
        if (Evaluaciones) {
            const notasMaximasPorUnidad = {};
            const conteoEvaluacionesPorUnidad = {};
            Evaluaciones.forEach((evaluacion) => {
                const { idUnidad, nota } = evaluacion;
                if (
                    !notasMaximasPorUnidad[idUnidad] ||
                    nota > notasMaximasPorUnidad[idUnidad]
                ) {
                    notasMaximasPorUnidad[idUnidad] = nota;
                }
                if (!conteoEvaluacionesPorUnidad[idUnidad]) {
                    conteoEvaluacionesPorUnidad[idUnidad] = 1;
                } else {
                    conteoEvaluacionesPorUnidad[idUnidad]++;
                }
            });
            let sumaNotas = 0;
            let totalUnidades = 0;
            for (const unidad in notasMaximasPorUnidad) {
                sumaNotas += notasMaximasPorUnidad[unidad];
                totalUnidades++;
            }
            const promedio = totalUnidades === 0 ? 0 : sumaNotas / totalUnidades;
            return promedio.toFixed(2);
        } else {
            return 0;
        }
    }

    //     let jwt = window.localStorage.getItem("jwt");
    //     let IdPersonaCurso = cursoPersona[0].idPersonaCurso;
    //     ObtenerCertificadoPersonaCurso({ jwt, IdPersonaCurso }).then(async (dataCert) => {

    //         // let jwt = window.localStorage.getItem("jwt");
    //         let nombrealumno =
    //             (Persona.nombres == null ? " " : Persona.nombres.trim()) +
    //             " " +
    //             (Persona.primerApellido == null ? " " : Persona.primerApellido.trim()) +
    //             " " +
    //             (Persona.segundoApellido == null ? " " : Persona.segundoApellido.trim());
    //         let nombrecursoprograma = curso.nombre;
    //         let ubicacion = "Lima";
    //         let enlace = "";
    //         let codigo = dataCert.codigoCertificado;// curso.codigoProducto; // Math.floor(Math.random() * 10000000).toString().padStart(12, '0');
    //         let totalhoras = curso.duracion.replace(/[^0-9.,]/g, '') ?? "0";// sumaDeDuraciones.toString();
    //         let fechainicio = cursoPersona[0].fechaActivacion;
    //         let fechafin = cursoPersona[0].finCurso?? cursoPersona[0].fechaVigencia;
    //         let jsonData = JSON.stringify({
    //             nombrealumno,
    //             nombrecursoprograma,
    //             ubicacion,
    //             enlace,
    //             codigo,
    //             totalhoras,
    //             fechainicio,
    //             fechafin,
    //         });
            
    //         try {
    //             setspinnerCertificado(true)
    //             setButtonDisabledCertificado(true)
    //             await CertificadoFCursoAdmi({ jwt, jsonData }).then((data) => { });
    //             setButtonDisabledCertificado(false)
    //             setspinnerCertificado(false)
    //         } catch (error) {
    //             setspinnerCertificado(false)
    //             alert.error("Error en la función CertificadoFCursoAdmi:", error);
    //         }
    //     })
    // };
    const onDownloadCertificado = async() => {
        try{
            navigate("/" + PrivateRoutes.HOME + "/ShareCertificate/Course/" + cursoPersona[0].idCurso,{
                state: {downloading:true}
            });

            const res = await handleDownloadCertificado({
                cursoPersona: cursoPersona[0],
                // curso,
                persona: Persona,
                tipo:"Curso"
            });

            navigate("/" + PrivateRoutes.HOME + "/ShareCertificate/Course/" + cursoPersona[0].idCurso,{
                state: {downloading:false, res}
            });

        }catch(error){
            toast.error(error,{ autoClose: 3000})
        }
    };

    const handleDownloadNotas = async () => {
        let jwt = window.localStorage.getItem("jwt");
        const currentDate = new Date();
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}_${String(currentDate.getMonth() + 1).padStart(2, '0')}_${String(currentDate.getFullYear()).slice(-2)}`;
        let IdPersonaCurso = cursoPersona[0].idPersonaCurso;
        ObtenerCertificadoPersonaCurso({ jwt, IdPersonaCurso }).then(async (dataCert) => {
            let nombrealumno =
                (Persona.nombres == null ? " " : Persona.nombres.trim()) +
                " " +
                (Persona.primerApellido == null ? " " : Persona.primerApellido.trim()) +
                " " +
                (Persona.segundoApellido == null ? " " : Persona.segundoApellido.trim());
            let nombrecursoprograma = curso.nombre;
            let ubicacion = "Lima";
            let enlace = urlToShare //dataCert.LinkCDN
                ? `${urlToShare}${Persona.primerApellido.trim()}-${formattedDate.trim()}-${"DN_"+dataCert.codigoCertificado.split('-').slice(1, 3).join('-').trim()}.pdf`
                : '';
            const fileName = `${Persona.primerApellido.trim()}-${formattedDate.trim()}-${"DN_"+dataCert.codigoCertificado.split('-').slice(1, 3).join('-').trim()}`;
            const codigo = dataCert.codigoCertificado;
            const enlaceQR = constantes.URL_CERTIFICATE +"/ValidateCertificateQR?codigo="+ dataCert.codigoCertificado + "&tipo=2";
            let promedionotaD = 0;
            var detalle = [];
            for (var j = 0; j < listaUnidades.length; j++) {
                var evaluacionesUnidad = Evaluaciones.filter(
                    (x) => x.idUnidad === listaUnidades[j].idUnidad
                );
                let notas;
                let notaMasAlta = 0;
                if (evaluacionesUnidad.length > 0) {
                    notas = evaluacionesUnidad.map((evaluacion) => evaluacion.nota);
                    notaMasAlta = Math.max(...notas);
                }
                let detalleUnidad = {
                    nombremodulo: listaUnidades[j].descripcion,
                    promedio: notaMasAlta,
                    orden: j + 1,
                };
                promedionotaD = promedionotaD + notaMasAlta;
                detalle.push(detalleUnidad);
            }
            promedionotaD = (promedionotaD / listaUnidades.length).toFixed();
            let promedionota = promedionotaD.toString();
            let jsonData = JSON.stringify({
                nombrealumno,
                nombrecursoprograma,
                ubicacion,
                enlace,
                enlaceQR,
                codigo,
                promedionota,
                detalle,
            });
            const dataCDN = {
                Extension: enlace.split('.').pop(),
                NombreCDN: fileName
            };
            try {
                setspinnerNotas(true)
                setButtonDisabledNotas(true)
                const response = { link: enlace, fileName };
                await CertificadoFCursoAdmiNotas({ jwt, jsonData, dataCDN, response }).then((data) => { });
                setButtonDisabledNotas(false)
                setspinnerNotas(false)
            } catch (error) {
                setspinnerNotas(false)
                alert.error("Error en la función CertificadoFCursoAdmi:", error);
            }
        })
    };

    return (
        <div className="p-fluid formgrid grid progreso-mobile  ">

            <CardDownload cursoPersona={cursoPersona} isButtonDisabledMateriales={isButtonDisabledMateriales} handleDownloadMaterialesCurso={handleDownloadMaterialesCurso} spinnerMateriales={spinnerMateriales} ProgressSpinner={ProgressSpinner} />



            <div className="flex interna-material w-full mb-2">
                <div className="interna-material-info">
                    <span className="subtitle text-sm h3" data-v-48f3e599="">
                        Certificado del curso
                    </span>
                </div>
                <div
                    className={
                        cursoPersona[0].idEstado === 1 &&
                            Evaluaciones && cursoPersona[0].idCondicion !==2 &&
                            calcularPromedioNotasPorUnidad() >= configuraciones?.filter(z => z.codigo === "NOTA_MINIMA_APROB")[0].valor && isButtonDisabledCertificado=== false
                            ? "flex align-items-center justify-content-center interna-material-download"
                            : "flex align-items-center justify-content-center interna-material-download-apagado"
                    }
                    style={{
                        width: "77px",
                        height: "100%",
                    }}
                    onClick={() => {
                        if (cursoPersona[0].idEstado === 1 && cursoPersona[0].idCondicion !==2 &&
                            Evaluaciones &&
                            calcularPromedioNotasPorUnidad() >= configuraciones?.filter(z => z.codigo === "NOTA_MINIMA_APROB")[0].valor
                        ) {
                            onDownloadCertificado()
                        }
                    }}
                >
                    {spinnerCertificado ? (
                       <ProgressSpinner style={{ width: "50px", height: "50px" }} />
                    ) : (
                      <img src={iconDownload} width={"17.5px"} height={"21px"}></img>
                    )}
                    {/* <img src={iconDownload} width={"17.5px"} height={"21px"}></img> */}
                </div>
                {/* <ButtonZegel
              height="100%"
              label=""
              width="77px"
              color="Quaternary"
              disabled={
                cursoPersona[0].idEstado == 1 &&
                Evaluaciones &&
                calcularPromedioNotasPorUnidad() >= configuraciones?.filter(z => z.codigo === "NOTA_MINIMA_APROB")[0].valor
                  ? false
                  : true
              }
              onClick={() => handleDownloadCertificado()}
            >
              <img src={iconDownload} width={"25px"} height={"30px"}></img>
            </ButtonZegel> */}
            </div>

            <div className="flex interna-material w-full mb-2">
                <div className="interna-material-info">
                    <span className="subtitle text-sm h3" data-v-48f3e599="">
                        Detalles de notas
                    </span>
                </div>
                <div
                    className={
                        cursoPersona[0].idEstado === 1 && cursoPersona[0].idCondicion !==2 &&
                            Evaluaciones &&
                            calcularPromedioNotasPorUnidad() >= configuraciones?.filter(z => z.codigo === "NOTA_MINIMA_APROB")[0].valor && isButtonDisabledNotas === false
                            ? "flex align-items-center justify-content-center interna-material-download"
                            : "flex align-items-center justify-content-center interna-material-download-apagado"
                    }
                    style={{
                        width: "77px",
                        height: "100%",
                    }}
                    onClick={() => {
                        if (
                            cursoPersona[0].idEstado === 1 && cursoPersona[0].idCondicion !==2 &&
                            Evaluaciones &&
                            calcularPromedioNotasPorUnidad() >= configuraciones?.filter(z => z.codigo === "NOTA_MINIMA_APROB")[0].valor
                        ) {
                            handleDownloadNotas();
                        }
                    }}
                >
                    {spinnerNotas ? (
                       <ProgressSpinner style={{ width: "50px", height: "50px" }} />
                    ) : (
                      <img src={iconDownload} width={"17.5px"} height={"21px"}></img>
                    )}
                    {/* <img src={iconDownload} width={"17.5px"} height={"21px"}></img> */}
                </div>
                {/* <ButtonZegel
              height="100%"
              label=""
              width="77px"
              color="Quaternary"
              disabled={
                cursoPersona[0].idEstado == 1 &&
                Evaluaciones &&
                calcularPromedioNotasPorUnidad() >= configuraciones?.filter(z => z.codigo === "NOTA_MINIMA_APROB")[0].valor
                  ? false
                  : true
              }
              onClick={() => handleDownloadNotas()}
            >
              <img src={iconDownload} width={"25px"} height={"30px"}></img>
            </ButtonZegel> */}
            </div>
        </div>
    )
}

export default GroupCardDownload